<div class="modal-container">
  <h1 i18n>Are you sure you want to delete this content?</h1>
  <h3 i18n>Note that deleting content that has been shared with other people may cause errors.</h3>
  <textarea
    name=""
    id=""
    cols="30"
    rows="2"
    placeholder="Reason for deletion"
    i18n-placeholder
    [formControl]="reason"
    [class.error]="!validInput"></textarea>
  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="submit-button" (click)="deleteContent()" i18n>Confirm</button>
  </section>
</div>
